import type { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import { Button as HeadlessButton } from "@headlessui/react";
import { tv } from "tailwind-variants";
import type { VariantProps } from "tailwind-variants";

import { Spinner } from "./Spinner";

const buttonVariants = tv({
  base: "rounded-md border-2 text-center font-bold transition-all w-full",
  variants: {
    variant: {
      primary:
        "bg-primary-950 border-primary-950 text-white hover:bg-white hover:font-normal hover:text-primary-900",
      secondary:
        "border-primary-950 text-primary-950  hover:bg-primary-950 hover:font-normal hover:text-white",
      secondaryRed:
        "border-error-700 text-error-700  hover:bg-error-700 hover:font-normal hover:text-white",
    },
    size: {
      sm: "px-2 py-1 text-xs",
      md: "px-4 py-3 text-sm",
      lg: "px-4 py-2 text-base",
    },
    disabled: {
      true: "pointer-events-none border-neutral-500 bg-neutral-500 font-bold text-white",
      false: "",
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "md",
    disabled: false,
  },
});

export type ButtonProps = ComponentPropsWithoutRef<"button"> &
  VariantProps<typeof buttonVariants> &
  PropsWithChildren & { isLoading?: boolean };

export function Button({
  variant,
  size,
  disabled,
  className,
  children,
  isLoading,
  ...props
}: ButtonProps) {
  return (
    <HeadlessButton
      className={buttonVariants({ variant, size, disabled, className })}
      {...props}
    >
      {isLoading ? <Spinner /> : children}
    </HeadlessButton>
  );
}
